import { Button, Stack, Typography } from '@mui/material';
import { dateTimeFormatter } from 'core/utils/commonUtils';
import { getOrderStateName } from 'core/utils/orderUtils';
import PageHeaderBackLink from 'layout/pages/PageHeaderBackLink';
import PageHeaderText from 'layout/pages/PageHeaderText';
import PageHeaderWrapper from 'layout/pages/PageHeaderWrapper';
import { isEmpty } from 'lodash';
import { OrderStateEnum } from 'models/enums/orderStateEnum';
import type { FC } from 'react';

const OrderEditPageHeader: FC<OrderEditPageHeaderProps> = (props) => {
  const {
    onArchiveOrder,
    onUnarchiveOrder,
    onWorkOrder,
    orderNumber,
    orderDateCreate,
    orderState,
  } = props;

  const isArchived = orderState === OrderStateEnum.Archive;
  const isRequest = orderState === OrderStateEnum.Request;

  const titlePrefix = getOrderStateName(orderState ?? OrderStateEnum.Request);

  const orderName = isEmpty(orderNumber)
    ? 'Новая заявка'
    : `${titlePrefix} №${orderNumber ?? ''}`;

  const [backLinkName, backLink] = isRequest
    ? ['Заявки', '/requests']
    : isArchived
    ? ['Архив', '/archive']
    : ['Заказы', '/orders'];

  return (
    <PageHeaderWrapper alignItems={{ xs: 'center' }}>
      <Stack>
        <PageHeaderBackLink to={backLink} name={backLinkName} />
        <PageHeaderText align={['center', 'left']} text={orderName} />
        <Typography
          sx={{ textAlign: ['center', 'left'] }}
          align='center'
          color={'text.secondary'}>
          Дата создания: {dateTimeFormatter.format(orderDateCreate ?? new Date())}
        </Typography>
      </Stack>

      <Stack direction={'row'} gap={1}>
        {isRequest && (
          <Button variant='contained' onClick={onWorkOrder}>
            В работу
          </Button>
        )}

        {!isArchived && (
          <Button
            variant='outlined'
            onClick={onArchiveOrder}
            aria-label='Переместить в архив'>
            В архив
          </Button>
        )}

        {isArchived && (
          <Button variant='outlined' onClick={onUnarchiveOrder}>
            Извлечь из архива
          </Button>
        )}
      </Stack>
    </PageHeaderWrapper>
  );
};

export interface OrderEditPageHeaderProps {
  orderNumber?: string;
  orderDateCreate?: Date;
  orderState?: OrderStateEnum;
  onArchiveOrder?: VoidFunction;
  onUnarchiveOrder?: VoidFunction;
  onWorkOrder?: VoidFunction;
}

export default OrderEditPageHeader;
